import React from 'react';
import { saveAs } from 'file-saver'; // To save the CSV file
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title as ChartTitle,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import GetAppIcon from '@mui/icons-material/GetApp';
import { AXIS_TICKS, GRID_COLOUR, TOOLTIP } from '../dashboard/chartTheme';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ChartTitle,
  Tooltip,
  Legend
);

export function LineGraph({ title, labels, colour, datasets, label }) {
  const options = {
    elements: {
      line: {
        tension: 0.3,
        borderWidth: 2,
      },
      point: {
        radius: 2,
        hoverRadius: 5,
      },
    },
    interaction: { mode: 'index', intersect: false },
    scales: {
      x: { grid: { display: false }, ticks: AXIS_TICKS },
      y: {
        beginAtZero: true,
        grid: { color: GRID_COLOUR, drawBorder: false },
        ticks: AXIS_TICKS,
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 10, boxHeight: 10, padding: 16, ...AXIS_TICKS },
      },
      // The heading above the chart already shows the title.
      title: {
        display: false,
        text: title,
      },
      tooltip: TOOLTIP,
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label,
        data: datasets,
        borderColor: colour,
        backgroundColor: colour,
      },
    ],
  };

  // Function to export the data to CSV
  const exportDataToCSV = () => {
    if (!datasets.length || !labels.length) {
      return;
    }

    // CSV header
    let csvContent = `Date, ${label}\n`;

    // Assuming `datasets` is an array of values for each label
    datasets.forEach((value, index) => {
      csvContent += `${labels[index]}, ${value}\n`;
    });

    // Create a Blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${title}.csv`);
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-3">
        <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
        <button
          type="button"
          onClick={exportDataToCSV}
          className="shrink-0 border border-gray-300 hover:border-claret-500 hover:text-claret-500 px-3 py-1 rounded-md text-gray-700 text-xs flex items-center gap-1 transition-colors"
        >
          <GetAppIcon fontSize="small" />
          <span>Export CSV</span>
        </button>
      </div>

      {/* Line chart rendering */}
      <Line options={options} data={data} />
    </div>
  );
}
